export var PageType = /*#__PURE__*/ function(PageType) {
    PageType["HOMEPAGE"] = "homepage";
    PageType["NEWS_LISTING_PAGE"] = "news_listing_page";
    PageType["RESEARCH_GROUP_LISTING_PAGE"] = "research_group_listing_page";
    PageType["RESEARCH_PLATFORM_LISTING_PAGE"] = "research_platform_listing_page";
    PageType["EVENT_LISTING_PAGE"] = "event_listing_page";
    PageType["JOB_LISTING_PAGE"] = "job_listing_page";
    PageType["CONTENT_PAGE"] = "content_page";
    return PageType;
}({});

//# sourceMappingURL=PageType.js.map